function bindPostForms(forms) {
  forms.forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      fetchCaptcha(form)
        .then((token) => {
          fetchAction(event.target, token).then((result) => {
            form.reset();
            showToast(result.message, 'success');
          });
        })
        .catch((error) => {
          console.error('ReCAPTCHA error:', error);
          showToast('Chyba zabezpečení formuláře.', 'error');
        });
    });
  });
}

function fetchCaptcha(form) {
  return new Promise((resolve, reject) => {
    const captchaInput = form.querySelector(`[name='${form.name}[captcha]']`);

    if (!captchaInput) {
      console.error('ReCAPTCHA input field is missing.');
      showToast('Chyba zabezpečení formuláře.', 'error');
      reject(new Error('ReCAPTCHA input field is missing.'));
      return;
    }

    grecaptcha
      .execute(captchaInput.dataset.sitekey, { action: 'contact_form' })
      .then((token) => {
        captchaInput.value = token;
        resolve(token);
      })
      .catch((error) => {
        console.error('ReCAPTCHA execution failed:', error);
        reject(error);
      });
  });
}

function fetchAction(form, captchaToken, page = null, disableCaptcha = false) {
  const formData = new FormData(form);
  const queryParams = new URLSearchParams();

  if (page !== null) {
    formData.set('page', page);
    queryParams.set('page', page);
  }

  for (const [key, value] of formData.entries()) {
    if (!key.includes('captcha')) {
      queryParams.append(key, value);
    }
  }

  if (!disableCaptcha) {
    formData.set(`${form.name}[captcha]`, captchaToken);
  }

  const formElements = bindFormElements(form);
  formElements.toggleDisabled();

  return fetch(form.action, {
    method: 'POST',
    body: formData,
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'X-language': document.documentElement.lang },
  })
    .then((response) => response.json())
    .then((result) => {
      if (result.success) {
        return result;
      } else {
        throw new Error(result.error || result.errors);
      }
    })
    .catch((error) => {
      console.error('Fetch error:', error);
      const errorText = Array.isArray(error) ? error.join('\n') : error.message;
      showToast('Při odesílání formuláře došlo k chybě. \n Details: ' + errorText, 'error');
      throw error;
    })
    .finally(() => {
      formElements.toggleDisabled();
    });
}

function bindFormElements(form) {
  return {
    elements: form ? form.querySelectorAll("input.form-control, [type='checkbox'], [type='radio'], textarea, button") : null,
    toggleDisabled: function () {
      this.elements.forEach((element) => {
        element.toggleAttribute('disabled');
      });
    },
  };
}
